import { render, staticRenderFns } from "./itemSystem.vue?vue&type=template&id=5a4b15d2&scoped=true"
import script from "./itemSystem.vue?vue&type=script&lang=js"
export * from "./itemSystem.vue?vue&type=script&lang=js"
import style0 from "./itemSystem.vue?vue&type=style&index=0&id=5a4b15d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b15d2",
  null
  
)

export default component.exports